// extracted by css-extract-rspack-plugin
export default {"cls1":"NewCitationPing-cls1_-Qu","cls2":"NewCitationPing-cls2_PnR NewCitationPing-cls1_-Qu"};